<template>
    <div>
    </div>
</template>

<script>
import { tempCodeIssue, redirectCheck } from "../../../resources/api/sso.js";
import { logOutProc } from "../../../resources/api/logOut";
import { mapActions } from "vuex";

export default {
    data() {
        return {
        };
    },

    async created() {
        // 로그인 여부
        const isLoggedIn = this.$store.state.loginMode === 'S'
            ? !!this.$store.state.mbrId
            : !!this.$store.state.authorization;
        const redirectUrl = this.$route.query.redirectUrl; // $route가 encode된 URL을 자동 decode함
        const mode = this.$route.query.mode; // mode (예: 'logout')
        const prompt = this.$route.query.prompt; // prompt (예: 'none' = 미로그인 시 로그인 화면 대신 redirectUrl 로 복귀)

        try {
            if (isLoggedIn) {
                // 로그아웃
                if(mode === 'logout') {
                    // redirectUrl이 있으면 로그아웃 후 그 주소로 이동 (자체 로그인 화면을 가진 연동 시스템용)
                    if(redirectUrl) {
                        await this.fnLogOutAndMove(redirectUrl);
                        return;
                    }
                    // mode가 'logout'인 경우 로그아웃 API 호출
                    await this.fnlogOut();
                    return;
                }

                const response = await tempCodeIssue();
                let tempCode = response.data.data;

                if(redirectUrl) {
                    // redirectUrl에 tempCode 파라미터 추가
                    const url = new URL(redirectUrl);
                    url.searchParams.append('tempCode', tempCode);
                    window.location.href = url.toString();
                } else {
                    // redirectUrl가 없으면 로그인 페이지로 이동
                    this.$router.push({ path: '/login.page'});
                }
            } else {
                // 이미 로그아웃 상태에서 redirectUrl이 있는 로그아웃 요청이면 그 주소로 이동
                if(mode === 'logout' && redirectUrl) {
                    await this.fnMoveRedirect(redirectUrl);
                    return;
                }
                // prompt=none 이면 로그인 화면 대신 redirectUrl?ssoError=login_required 로 복귀
                if(prompt === 'none' && redirectUrl) {
                    await this.fnReturnLoginRequired(redirectUrl);
                    return;
                }
                // 토큰이 없으면 로그인 페이지로 이동
                this.$router.push({ path: '/login.page', query: { redirectUrl } });
            }
        } catch (error) {
            // 에러 발생 시 로그인 페이지로 이동
            this.$router.push({ path: '/login.page', query: { redirectUrl } });
        }
    },

    watch: {
    },

    methods: {
        ...mapActions(["logout"]),
        async fnlogOut() {
            await this.logout();
        },

        // 돌려보낼 주소 허용 여부
        async fnCheckRedirect(url) {
            try {
                const response = await redirectCheck(url);
                return response.data.data?.allowed !== false;
            } catch (error) {
                console.error('돌려보낼 주소 확인 실패:', error);
                return true;
            }
        },

        // 로그아웃 후 redirectUrl 로 이동 (허용되지 않은 주소면 기존 로그아웃)
        async fnLogOutAndMove(url) {
            if(!await this.fnCheckRedirect(url)) {
                await this.fnlogOut();
                return;
            }
            try {
                await logOutProc();
            } catch (error) {
                console.error('로그아웃 실패:', error);
            } finally {
                this.$store.commit("setStoreReset");
                localStorage.clear();
                sessionStorage.clear();
                window.location.href = url;
            }
        },

        // redirectUrl 로 이동 (허용되지 않은 주소면 로그인 페이지)
        async fnMoveRedirect(url) {
            if(!await this.fnCheckRedirect(url)) {
                this.$router.push({ path: '/login.page' });
                return;
            }
            window.location.href = url;
        },

        // 미로그인 결과를 redirectUrl 에 담아 복귀 (허용되지 않은 주소면 로그인 페이지)
        async fnReturnLoginRequired(url) {
            if(!await this.fnCheckRedirect(url)) {
                this.$router.push({ path: '/login.page' });
                return;
            }
            const returnUrl = new URL(url);
            returnUrl.searchParams.set('ssoError', 'login_required');
            window.location.href = returnUrl.toString();
        },
    }
};
</script>

<style scoped></style>
